// TSS vite/04 §"Endpoint paths". baseURL already includes /api/v1.
// Dashboard KPIs — un único GET read-puro, multinivel por ?view= (admin-kpis.md).

export const kpiPaths = {
    base: () => 'admin/kpis',
};
